import { BoardMembers, BoardMemberCache } from "shared/datamodel/schemas/board";
import { editBoardMembers, getBoardMembers } from "frontend/api";
import { boardMemberCacheAtom } from "state-atoms";
import { useGenericCache } from "./use-general-cache";

export function useBoardMembersCache() {
  const { getItem, isLoading, updateItemCache } = useGenericCache<BoardMembers, BoardMemberCache, "documentId", null>({
    cacheAtom: boardMemberCacheAtom,
    fetchById: async (documentId: string) => {
      const board = await getBoardMembers(documentId);
      return board;
    },
    entityName: "boards",
    entityKey: "board",
    keyField: "documentId",
    updateItem: async (item: Partial<BoardMembers>) => {
      if (item.documentId && item.members) {
        await editBoardMembers({ documentId: item.documentId, members: item.members });
      }
      return { ...item, members: item.members?.filter((m) => m.deleted !== true) } as BoardMembers;
    },
  });

  return { getBoardMembers: getItem, isLoading, updateBoardMembers: updateItemCache };
}
